import type Module from 'mini-common-schema/lib/schema/Module';
import { trackLargestSurfaceRender } from 'bootstrap/lib/trackLargestSurfaceRender';
import type { ModuleLaunchType } from 'bootstrap/lib/trackLargestSurfaceRender';
import {
    MAIL_LIST_RENDERED,
    PEOPLE_LIST_RENDERED,
    DV_RENDER_COMPLETE,
    AV_MOUNT_UPDATE_COMPLETE,
} from 'mini-app-constants/lib/commonEventSignalConstants';

export const trackModuleLargestSurfaceRender = (
    module: Module,
    bootType?: string,
    isModuleSwitch?: boolean,
    moduleLaunchType?: ModuleLaunchType
) => {
    switch (module) {
        case 0:
            trackLargestSurfaceRender(
                [MAIL_LIST_RENDERED],
                null,
                null,
                isModuleSwitch,
                moduleLaunchType
            );
            break;
        case 1:
            trackLargestSurfaceRender(
                [AV_MOUNT_UPDATE_COMPLETE, DV_RENDER_COMPLETE],
                null,
                null,
                isModuleSwitch,
                moduleLaunchType
            );
            break;
        case 2:
            trackLargestSurfaceRender(
                [PEOPLE_LIST_RENDERED],
                null,
                null,
                isModuleSwitch,
                moduleLaunchType
            );
            break;
        default:
            break;
    }
};
